import { ListFacetComponentModel, ListFacetItemComponentModel } from '../lib/list-facet/list-facet.interfaces';

export function countSelectedItems(model: ListFacetComponentModel | null): number {
    function countActiveItems(list: ListFacetItemComponentModel[] | undefined): number {
        if (!list) return 0;
        return list.filter((i: any) => i.state !== null).length;
    }
    return countActiveItems(model?.staticItems) + countActiveItems(model?.dynamicItems);
}
